import * as ApiManager from './_manager';
import store from '@/store';

export const venue = {
  create: (payload = null) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/venue/create`,
      payload
    );
  },

  get: (payload = null) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/venue/get`,
      payload
    );
  },

  list: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/venue/list`,
      payload
    );
  },

  delete: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/venue/${payload.id}/delete`,
      payload
    );
  },

  update: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/venue/` +
        payload.id +
        `/update`,
      payload
    );
  },
  updateSeats: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/venue/` +
        payload.venue_id +
        `/updateSeats`,
      payload
    );
  },
  markUnavailableSeats: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/venue/` +
        payload.venue_id +
        `/markUnavailableSeats`,
      payload
    );
  },
  markAvailableSeats: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/venue/` +
        payload.venue_id +
        `/markAvailableSeats`,
      payload
    );
  },
  markSeatsInaccessible: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/venue/` +
        payload.venue_id +
        `/markSeatsInaccessible`,
      payload
    );
  },

  markSeatsAccessible: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/venue/` +
        payload.venue_id +
        `/markSeatsAccessible`,
      payload
    );
  },
  duplicateVenue: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/venue/` +
        payload.venue_id +
        `/duplicateVenue`,
      payload
    );
  },
};
